import React from 'react';
import PropTypes from 'prop-types';
import { Spinner, SpinnerSize } from '@fluentui/react';

export const InlineLoading = ({ text }) => (
  <Spinner className="inline-loading" size={SpinnerSize.medium} labelPosition="right" label={text} tabIndex={0} />
);

InlineLoading.propTypes = {
  text: PropTypes.string,
};

InlineLoading.defaultProps = {
  text: 'Loading...',
};
